<template>
  <div class="idata wrapW">
    <ul class="wrapW">
      <li v-for="(item,index) in list" :key="index">
        <div class="kuan">
          <div class="shu">
            <countTo class="countTo" :startVal='startVal' :endVal='item.num' :duration='duration' :separator='separator'></countTo><span>
              <!-- {{item.unit}} -->
            </span>
          </div>
          <div class="details">{{item.name}}</div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import countTo from 'vue-count-to'
export default {
  name: 'idata',
  props: {
    countToB: Boolean
  },
  components: {
    countTo
  },
  data () {
    return {
      duration: 4000,
      startVal: 0,
      separator: '',
      list: []
    }
  },
  watch: {
    'countToB': function () {
      if (this.countToB) {
        this.getData()
      }
    }
  },
  mounted () {
    // 
  },
  methods: {
    getData () {
      let that = this
      this.$axios.get(process.env.API_HOSTT + '/os/getData', {
      }).then(
        function (res) {
          res = res.data.data
          for (let i = 0; i< res.length; i++) {
            res[i].num = res[i].num *1
          }
          that.list = res
        }
      ).catch(error => console.log(error))
    }
  }
}
</script>
<style lang="stylus" scoped>
.idata
  position relative
  z-index 9
  top -0.64rem
  box-shadow: 0px 5px 19px 0px rgba(9, 9, 9, 0.16);
  border-radius .06rem
  background #fff
  height 1.34rem
  ul
    margin 0 auto
    display flex
    li
      width 25%
      text-align center
      .kuan
        width max-content
        margin 0 auto
        text-align left
      .shu
        color #D22016
        margin-top .25rem
        height .5rem
        line-height .5rem
        span
          font-size .2rem
        span.countTo
          font-size .32rem
          font-weight 800
          position relative
          padding-right .3rem
          font-family 'FanWunMing-TW-Heavy'
        span.countTo:before
          content '+'
          font-size .3rem
          position absolute
          top 0px
          right 0px
          line-height .1rem
      .details
        height .25rem
        line-height .25rem
        color #666666
        font-size .16rem
        font-weight 400
        margin-bottom .22rem
</style>



// WEBPACK FOOTER //
// src/pages/index/components/idata.vue